








import { SXCompany, SXSurvey } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WSurveyAbout extends BaseComponent {
	@Prop({ type: SXSurvey, required: true })
	survey!: SXSurvey;
}
